import { IHttpApi } from '@cian/http-api/shared/http';

import {
  fetchGetComparisonDesktop,
  IGetComparisonDesktopResponse,
} from '../../repositories/offers-comparison/v2/get-comparison-desktop';
import { mapComparisonResponse, mapComparisonResponseError } from '../../mappers/comparison';
import { assertNotFoundError } from './assert';
import { prepareComparison } from '../../mappers/comparison/prepareComparison';
import { ICompare } from './service';
import { TCompareType } from '../../types/compareType';

interface IParameters {
  compareType: TCompareType;
}

export interface IFetchComparison {
  httpApi: IHttpApi;
  parameters: IParameters;
}

export async function fetchComparison({ httpApi, parameters }: IFetchComparison): Promise<ICompare> {
  const response = await fetchGetComparisonDesktop({
    httpApi,
    parameters: {
      onlyDifferences: parameters.compareType === 'differences',
    },
    mappers: {
      200: mapComparisonResponse,
      400: mapComparisonResponseError,
    },
  });

  assertNotFoundError(response);

  return prepareComparison({
    response: response.response as IGetComparisonDesktopResponse,
    compareType: parameters.compareType,
  });
}
